import * as React from 'react';

import { Formatter as DimensionsFormatter } from './formatter';

export const Labels: React.FC<{
  resource: {
    length?: number;
    width?: number;
    height?: number;
    dimensionsOverwritten?: boolean;
    dimensions_overwritten?: boolean; // Legacy Angular format
  };
}> = ({ resource }) => {
  const dimensionsOverwritten = resource.dimensionsOverwritten ?? resource.dimensions_overwritten;
  return (
    <>
      <span className="label label-info">
        <DimensionsFormatter resource={resource} fallback="No Dimensions" />
      </span>
      {dimensionsOverwritten && (
        <>
          <br />
          <span className="label label-dark">Dim Overwritten</span>
        </>
      )}
    </>
  );
};
